export default {
  $ID: 'koeebox',
  Name: 'KOEEBOX',
  Modules: {
    DefaultModuleImpl: {
      Pages: [
        {
          Path: '/boxes',
          $ID: 'Boxes',
          $Type: 'SmartOeeBoxes',
          AllowedRoles: ['Admin', 'User'], // роль пользователя
        },
        {
          Path: '/effieciencylossbydeviceId/:deviceId',
          $ID: 'EventsPageDevice',
          $Type: 'EventsPage',
          AllowedRoles: ['Admin', 'User'],
        },
        {
          Path: '/effieciencyloss',
          $ID: 'EventsPage',
          $Type: 'EventsPage',
          AllowedRoles: ['Admin', 'User'],
        },
        {
          Path: '/users',
          $Type: 'Users',
          $ID: 'Users',
          AllowedRoles: ['Admin'],
        },
        {
          Path: '/effieciencylossbyid/:notificationId',
          $ID: 'EffieciencyLossEditPage',
          $Type: 'EffieciencyLossEditPage',
          AllowedRoles: ['Admin', 'User'],
        },
        {
          Path: '/settings/profile',
          $Type: 'SettingsProfile',
          $ID: 'SettingsProfile',
          AllowedRoles: ['Admin', 'User'],
        },
        {
          Path: '/settings/box/:boxId',
          $ID: 'SettingsBox',
          $Type: 'SmartOeeSettingsBox',
          AllowedRoles: ['Admin', 'User'],
        },
        {
          Path: '/settings/billing',
          $Type: 'SmartOeeBilling',
          $ID: 'SmartOeeBilling',
          AllowedRoles: ['Admin'],
        },
        {
          Path: '/requests',
          $Type: 'SupportRequests',
          $ID: 'SupportRequests',
          AllowedRoles: ['Admin', 'User'],
        },
        {
          Path: '/settings/addbox',
          $Type: 'SettingsAddBox',
          $ID: 'SettingsAddBox',
          AllowedRoles: ['Admin', 'User'],
        },
        // {
        //   Path: '/market/boxes',
        //   $Type: 'MarketBoxes',
        //   $ID: 'MarketBoxes',
        //   AllowedRoles: ['Admin', 'User', 'Guest'],
        // },
        // {
        //   Path: '/market/features',
        //   $Type: 'MarketFeatures',
        //   $ID: 'MarketFeatures',
        //   AllowedRoles: ['Admin'],
        // },
        // {
        //   Path: '/market/features/:featureId',
        //   $Type: 'SmartOeeMarketFeatureDetails',
        //   $ID: 'SmartOeeMarketFeatureDetails',
        //   AllowedRoles: ['Admin'],
        // },
        {
          Path: '/boxinfo/:deviceId',
          $ID: 'Boxinfo',
          $Type: 'box-info',
          AllowedRoles: ['Admin', 'User', 'Guest'],
        },
        {
          Path: '/boxinfo/iiot/:deviceId',
          $ID: 'boxiiot',
          $Type: 'BoxIiotDashboard',
          AllowedRoles: ['Admin', 'User', 'Guest'],
        },
        {
          Path: '/register/company',
          $Type: 'SmartOeeRegisterCompany',
          $ID: 'SmartOeeRegisterCompany',
          AllowedRoles: ['User'],
        },
        {
          Path: '/login',
          $ID: 'SmartOeeLogin',
          $Type: 'SmartOeeLogin',
          AllowedRoles: ['Guest'],
        },
        {
          Path: '/register',
          $Type: 'SmartOeeRegister',
          $ID: 'SmartOeeRegister',
          AllowedRoles: ['Guest'],
        },
        {
          Path: '/activation',
          $Type: 'VerifyEmail',
          $ID: 'VerifyEmail',
          AllowedRoles: ['Guest', 'User'],
        },
        {
          Path: '/password/reset',
          $Type: 'ResetPassword',
          $ID: 'ResetPassword',
          AllowedRoles: ['Guest'],
        },
        {
          Path: '/password/activate',
          $Type: 'ActivationPassword',
          $ID: 'ActivationPassword',
          AllowedRoles: ['Guest'],
        },
        {
          Path: '/password/restore&hash=:hash&lang=:lang',
          $Type: 'ConfirmPassword',
          $ID: 'ConfirmPassword',
          AllowedRoles: ['Guest'],
        },
        {
          Path: '/company/activation',
          $Type: 'CreatingCompany',
          $ID: 'CreatingCompany',
          AllowedRoles: ['Guest', 'User'],
        },
        {
          Path: '/api',
          $Type: 'ApiSettings',
          $ID: 'ApiSettings',
          AllowedRoles: ['Admin'],
        },
        {
          Path: '/bot',
          $Type: 'BotLinks',
          $ID: 'BotLinks',
          AllowedRoles: ['Admin', 'User'],
        },
        {
          Path: '/faq',
          $Type: 'Faq',
          $ID: 'Faq',
          AllowedRoles: ['Admin', 'User', 'Guest'],
        },
        {
          Path: '/sensors/ar/:sensorGuid',
          $Type: 'SensorAr',
          $ID: 'SensorAr',
          AllowedRoles: ['Admin', 'User', 'Guest'],
        },
        // {
        //   Path: '/maintenance',
        //   $Type: 'MaintenanceOee',
        //   $ID: 'MaintenanceOee',
        //   AllowedRoles: ['Admin', 'Guest', 'User']
        // }
      ],
    },
  },

  Navigation: {
    RoleBasedHomePages: {
      // домашняя страница, которая будет открываться для пользователей с ролью "Гость" по умолчанию
      // 'Guest': 'SmartOeeRegister'
    },
    SignInPage: 'SmartOeeLogin',
    HomePage: 'Boxes',
    Menu: [
      {
        $ID: 'Boxes',
        Action: {
          $Type: 'OpenPage',
          Page: 'Boxes',
        },
        Icon: 'koee',
        Caption: 'sidebar.titles.boxes',
        IconClass: 'fill-icon',
        IconSize: '24px',
      },
      {
        $ID: 'EffieciencyLoss',
        Action: {
          $Type: 'OpenPage',
          Page: 'EventsPage',
        },
        Icon: 'clipboard',
        Caption: 'sidebar.titles.categorization',
      },
      {
        $ID: 'Users',
        Action: {
          $Type: 'OpenPage',
          Page: 'Users',
        },
        Icon: 'users',
        Caption: 'sidebar.titles.users',
      },
      {
        $ID: 'Market',
        Caption: 'sidebar.titles.market',
        Icon: 'shopping-bag',
        Items: [
          {
            $ID: 'MarketBoxes',
            Caption: 'sidebar.titles.devices',
            Action: {
              $Type: 'OpenPage',
              Page: 'MarketBoxes',
            },
          },
          {
            $ID: 'MarketFeatures',
            Caption: 'sidebar.titles.features',
            Action: {
              $Type: 'OpenPage',
              Page: 'MarketFeatures',
            },
          },
        ],
      },
      // {
      //   $ID: 'Requests',
      //   Action: {
      //     $Type: 'OpenPage',
      //     Page: 'SupportRequests',
      //   },
      //   Icon: 'message-circle',
      //   Caption: 'sidebar.titles.requests',
      // },
      {
        $ID: 'ApiSettings',
        Caption: 'sidebar.titles.apiSettings',
        Icon: 'link',
        Action: {
          $Type: 'OpenPage',
          Page: 'ApiSettings',
        },
      },
      {
        $ID: 'BotLinks',
        Caption: 'sidebar.titles.bot',
        Icon: 'telegram',
        Action: {
          $Type: 'OpenPage',
          Page: 'BotLinks',
        },
      },
      {
        $ID: 'SettingsAddBox',
        Caption: 'sidebar.titles.addBox',
        Icon: 'plus',
        Action: {
          $Type: 'OpenPage',
          Page: 'SettingsAddBox',
        },
      },
      {
        $ID: 'Faq',
        Caption: 'sidebar.titles.faq',
        Icon: 'help-circle',
        Action: {
          $Type: 'OpenPage',
          Page: 'Faq',
        },
      },
    ],
  },
  Settings: {
    //TODO: Settings
    Name: '',
  },
  ProjectSecurity: {
    UserRoles: ['Guest', 'User', 'Admin'],
    NeedAuthentication: true, // аутентификация включена для всего приложения
    AllowAnonimousUsers: true, // В приложении разрешены анонимные пользователи
    AnonimousUserRole: 'Guest', // Роль анонимного пользователя
  },
};
